import heroBg from "@/assets/hero-fashion-collage.png";
import JoinNowButton from "@/components/landing/JoinNowButton";
import SiteNav from "@/components/landing/SiteNav";
const Hero = () => {
  return <>
      <header className="relative min-h-[75vh] md:min-h-[80vh] overflow-hidden">
        <SiteNav transparent />
        
        {/* Full-screen background */}
        <div className="absolute inset-0 -z-10">
          <img src={heroBg} alt="Colorful fashion collage background with diverse models wearing modern outfits showcasing the latest fashion trends" className="h-full w-full object-cover" loading="eager" fetchPriority="high" width={1335} height={890} sizes="100vw" decoding="sync" />
          <div className="absolute inset-0 bg-black/40" />
        </div>

        {/* Centered content overlay */}
        <div className="relative z-10 flex flex-col items-center justify-center min-h-[75vh] md:min-h-[80vh] px-4 md:px-8 text-center">
          <h1 className="font-roxborough text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight tracking-tight text-white max-w-5xl animate-enter">
            Creator content,<br />
            <em className="italic">instantly</em> shoppable
          </h1>
          
          <p className="mt-6 md:mt-8 text-lg md:text-xl text-white/90 max-w-2xl">
            We use AI to match the outfits in your posts with real products from top fashion brands so you can earn more without doing anything extra.
          </p>
          
          <div className="mt-8 md:mt-10">
            <JoinNowButton />
          </div>
        </div>
      </header>
    </>;
};
export default Hero;